import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Alert, Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react'
import { auth } from '../../firebase/firebase'
import { LoadingButton } from '@mui/lab';
import { updatePassword } from 'firebase/auth';



const PerfilScreen = () => {

  const user = auth.currentUser;

  const [contrasena, setContrasena] = useState("")
  const [verificacionContrasena, setVerificacionContrasena] = useState("")
  const [mostrarContrasena, setMostrarContrasena] = useState(false)
  const [cargando, setCargando] = useState(false);
  const [alerta, setAlerta] = useState(false);
  const [colorAlerta, setColorAlerta] = useState("success");
  const [mensajeAlerta, setMensajeAlerta] = useState("");

  const handleChangeContrasena = (e) => {
      setContrasena(e.target.value)
  }

  const handleChangeVerificacionContrasena = (e) => {
      setVerificacionContrasena(e.target.value)
  }

  const handleClickShowPassword = () => {
      setMostrarContrasena(!mostrarContrasena);
  };

  const guardarDatos = () => {
    setCargando(true)
    setMensajeAlerta("");
    setColorAlerta("success");
    setAlerta(false);
    if(contrasena.length >= 6 && verificacionContrasena.length >= 6){
      if (contrasena === verificacionContrasena) {
        /* const user = auth.currentUser; */
        updatePassword(user, contrasena).then(() => {
          setMensajeAlerta("Contraseña actualizada con éxito");
          setColorAlerta("success");
          setCargando(false)
          setTimeout(setAlerta(true), 3000);
        }).catch((error) => {
          setMensajeAlerta("Ha ocurrido un error al actualizar la contraseña");
          setColorAlerta("error");
          setAlerta(true);
          setCargando(false)
        });
        
      }
      else {
        setMensajeAlerta("Las contraseñas no coinciden");
        setColorAlerta("error");
        setAlerta(true);
        setCargando(false)
        
      }
    }else{
      setMensajeAlerta("La contraseña debe tener 6 caracteres o más");
      setColorAlerta("error");
      setAlerta(true);
      setCargando(false)
    }
      
  };


  return (
    <div>
    <Box sx={{ marginLeft: "30%", width: '40%' }}>

      <Stack spacing={2} style={{ marginTop: "50px", marginRight: "50px", marginLeft: "50px" }}>
        <Typography variant="h4" style={{ textAlign: "center" }} color="primary">{user.email}</Typography>
        <FormControl variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">Nueva contraseña</InputLabel>
            <OutlinedInput
                id="outlined-adornment-password"
                type={mostrarContrasena ? 'text' : 'password'}
                value={contrasena}
                onChange={handleChangeContrasena}
                endAdornment={
                  <InputAdornment position="end">
                        <Tooltip title='Mostrar contraseña'>
                          <IconButton
                              onClick={handleClickShowPassword}
                              edge="end"
                              >
                              {mostrarContrasena ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </Tooltip>
                    </InputAdornment>
                }
                label="Nueva contraseña"
                />
        </FormControl>

        <FormControl variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password2">Confirmar nueva contraseña</InputLabel>
            <OutlinedInput
                id="outlined-adornment-password2"
                type={mostrarContrasena ? 'text' : 'password'}
                value={verificacionContrasena}
                onChange={handleChangeVerificacionContrasena}
                endAdornment={
                  <InputAdornment position="end">
                    <Tooltip title='Mostrar contraseña'>
                      <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          >
                          {mostrarContrasena ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                }
                label="Confirmar nueva contraseña"
                />
        </FormControl>

        {
          alerta && (
            <Alert severity={colorAlerta}>{mensajeAlerta}</Alert>
            
            )
            
          }

        <LoadingButton
            loading={cargando}
            variant='contained'
            onClick={guardarDatos}
            >
            Guardar Datos
        </LoadingButton>
      </Stack>
      </Box>
      
    </div>
  )        
}

export default PerfilScreen